import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import type { Vendor } from '@pedestal-panels/contracts';

/**
 * Grass Valley MCP-400 — master control panel.
 *
 * Phase 1 reference panel; establishes the Grass Valley token baseline.
 */
export const meta = {
  id: 'mcp-400',
  vendor: 'grassvalley' as Vendor,
  model: 'MCP-400',
  productName: 'Grass Valley MCP-400',
} as const;

@customElement('panel-mcp-400')
export class PanelMcp400Element extends LitElement {
  static override styles = [
    css`
      :host {
        display: block;
        inline-size: 100%;
        container-type: inline-size;
      }
    `,
  ];

  override render() {
    return html`<chassis-frame view-box="0 0 1000 600"></chassis-frame>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'panel-mcp-400': PanelMcp400Element;
  }
}
